import { TranslocoModule } from '@jsverse/transloco';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthNavComponent } from '../auth-nav/auth-nav.component';
import { ModalService } from '../../../shared/utils/services/modal.service';
import { ModalComponent } from '../../../shared/ui/modal/modal.component';
import {
  AppTrackingTransparency,
  AppTrackingStatusResponse,
} from 'capacitor-plugin-app-tracking-transparency';
import { DeviceService } from '../../../shared/services/device.service';

@Component({
  selector: 'qwiko-auth-shell',
  imports: [RouterModule, AuthNavComponent, ModalComponent, TranslocoModule],
  templateUrl: './auth-shell.component.html',
  styleUrl: './auth-shell.component.scss',
})
export class AuthShellComponent implements OnInit {
  private modalService = inject(ModalService);
  private deviceService = inject(DeviceService);

  constructor() {}
  async ngOnInit(): Promise<void> {
    if (this.deviceService.isIOS()) {
      await this.getStatus();
    }
  }

  async getStatus() {
    const response = await AppTrackingTransparency.getStatus();

    // console.log(response);
    const { status } = response;

    if (status === 'notDetermined') {
      await this.requestPermissionAppTrackingPermission();
    } else if (
      status === 'denied' ||
      status === 'restricted' ||
      status === 'authorized'
    ) {
      return;
    }
    return;
  }

  async requestPermissionAppTrackingPermission(): Promise<AppTrackingStatusResponse> {
    const response = await AppTrackingTransparency.requestPermission();
    // console.log(response);
    return response;
  }

  closeModal(modal: string) {
    this.modalService.close(modal);
  }
}
